// Import of creatApp from Vue 3 bundler.
import { createApp } from 'vue/dist/vue.esm-bundler.js';

// App imports.
import agendaApp from './vue/agenda.js';
import agendaItemApp from './vue/agendaItem.js';
import agendaWidgetApp from './vue/agendaWidget.js';
import productionApp from './vue/production.js';
import recommendationsApp from './vue/recommendations.js';
import quickSearchHomeApp from './vue/quickSearchHome.js';

document.addEventListener('DOMContentLoaded', () => {
    // Mounting containers listing and DOM targeting.
    const agendaOverviewContainer = document.getElementById('agenda');
    const agendaItemContainers = document.querySelectorAll('.agenda-result-item');
    const agendaWidgetContainer = document.getElementById('widget-agenda');
    const productionContainer = document.getElementById('production');
    const recommendationsContainer = document.getElementById('recommendations');
    const quickSearchHomeContainer = document.getElementById('quickSearchHome');

    // For each app, only build the Vue instance if the targeted element is present and mount the app on the targeted element.
    if (agendaOverviewContainer) {
        createApp(agendaApp).mount(agendaOverviewContainer);
    }

    agendaItemContainers.forEach(container => {
        createApp(agendaItemApp).mount(container);
    });

    if (agendaWidgetContainer) {
        createApp(agendaWidgetApp).mount(agendaWidgetContainer);
    }

    if (productionContainer) {
        createApp(productionApp).mount(productionContainer);
    }

    if (recommendationsContainer) {
        createApp(recommendationsApp).mount(recommendationsContainer);
    }

    if (quickSearchHomeContainer) {
        createApp(quickSearchHomeApp).mount(quickSearchHomeContainer);
    }
});
